import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/Sheet/Sheet";
import { format } from "date-fns";
import { useEffect, useState, type Dispatch, type SetStateAction } from "react";
import { useSignUp } from "@/artifacts/student/hooks/dashboard/useSignUp";
import { SingletonSignUpForm } from "@/artifacts/student/forms/dashboard/SingletonSignUpForm";
import { MultiWeekSignUpForm } from "@/artifacts/student/forms/dashboard/MultiWeekSignUpForm";

const SignUpSheet = ({
  open,
  onOpenChange,
  data,
  setOpenSignups,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: { rotation: any; session: any };
  setOpenSignups: Dispatch<
    SetStateAction<{
      sessions: any[];
      rotations: any[];
    }>
  >;
}) => {
  const [explorations, setExplorations] = useState<any[]>([]);

  const { loadExplorations, loading } = useSignUp();

  useEffect(() => {
    if (!data.session) return;
    loadExplorations(data.session._id, setExplorations);
  }, [data.session]);

  const onSuccess = (sessionId: string) => {
    setOpenSignups((prev) => {
      const session = prev.sessions.find((s) => s._id === sessionId);
      if (!session) return prev;

      const rotationId = session.rotation;

      const sessions = prev.sessions.filter((s) => s._id !== sessionId);

      const rotationStillHasSessions = sessions.some(
        (s) => s.rotation === rotationId,
      );
      const rotations = rotationStillHasSessions
        ? prev.rotations
        : prev.rotations.filter((r) => r._id !== rotationId);

      return { sessions, rotations };
    });
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right">
        <SheetHeader>
          <SheetTitle>
            Sign Up for {data.session.name} on{" "}
            {format(data.rotation.date, "MMMM dd, yyyy")}
          </SheetTitle>
          <SheetDescription>
            {data.session.singleton ? "Sign up" : "Submit preferences"} for{" "}
            {data.session.name} on {format(data.rotation.date, "MMMM dd, yyyy")}
            .
          </SheetDescription>
        </SheetHeader>
        {data.session.singleton ? (
          <SingletonSignUpForm
            data={{ explorations, sessionId: data.session._id }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        ) : (
          <MultiWeekSignUpForm
            data={{ explorations, sessionId: data.session._id }}
            loading={loading.loadExplorations}
            onSuccess={onSuccess}
          />
        )}
      </SheetContent>
    </Sheet>
  );
};

export { SignUpSheet };
